// extracted by mini-css-extract-plugin
export default {"reverse-order":"_k55pk6","reverseOrder":"_k55pk6"};